import { useVersion } from "@/hooks/use-version";
import { cn } from "@/lib/utils";

export const VersionRibbon = () => {
    const { data: version, isLoading } = useVersion();

    if (isLoading || !version || version === "") {
        return null;
    }

    let colors: string;
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === "development") {
        colors = "bg-blue-500 text-white";
    } else if (version === "DEV") {
        colors = "bg-blue-800 text-white";
    } else {
        colors = "bg-red-200 text-black";
    }

    return (
        <div className="fixed bottom-0 left-0 z-50 w-20 h-20 overflow-hidden pointer-events-none">
            <div
                className={cn(
                    "text-xs font-semibold shadow-md absolute w-28 text-center py-1 rotate-45 bottom-[19px] left-[-25px]",
                    colors,
                )}
            >
                {version}
            </div>
        </div>
    );
};
